<template>
  <div>





<h2 class="goth">Genitiv</h2>
<div class="grammatikparagrafbredd leftorient">


    <h4>Genitiv betecknar ägande</h4>
<p>Genitiv är ett kasus, som i första hand används för att beteckna ägande eller tillhörighet.
    Genitivformen på svenska är enkel.
    Man lägger till ett <b>-s</b> på <i>ägaren</i> och bildar <i>genitiv</i>. Genitivens <i>huvudord, det ägda,</i> står efter: </p>

<div class="ruta">

<div class="quasi-p">
<div class="p-stil"><div class="dubbelrad"><u><i>Bonden</i><b>s</b></u> &nbsp; <br><div class="minitext">genitiv</div></div></div>
<div class="p-stil"><div class="dubbelrad"><u><i> traktor</i></u>&nbsp;<br><div class="minitext">huvudord</div></div></div>
<div class="upp"><i>är röd.</i></div>
</div>




<div class="quasi-p">
<div class="p-stil"><div class="dubbelrad"><u><i>Huset</i><b>s</b></u> &nbsp; <br><div class="minitext">genitiv</div></div></div>
<div class="p-stil"><div class="dubbelrad"><u><i> läge</i></u>&nbsp;<br><div class="minitext">h.ord</div></div></div>
<div class="upp"><i>är fantastiskt.</i></div>
</div>

<div class="quasi-p">
<div class="p-stil"><div class="dubbelrad"><u><i>Lärarinnan</i><b>s</b></u> &nbsp; <br><div class="minitext">genitiv</div></div></div>
<div class="p-stil"><div class="dubbelrad"><u><i> bil</i></u>&nbsp;<br><div class="minitext">h.ord</div></div></div>
<div class="upp"><i>är grön.</i></div>
</div>


<div class="quasi-p">
<div class="p-stil"><div class="dubbelrad"><u><i>Barnen</i><b>s</b></u> &nbsp; <br><div class="minitext">genitiv</div></div></div>
<div class="p-stil"><div class="dubbelrad"><u><i> böcker</i></u>&nbsp;<br><div class="minitext">huvudord</div></div></div>
<div class="upp"><i>är intressanta.</i></div>
</div>

</div>


<br>
<h4>Huvudordet kommer före genitiven på tyska</h4>
<p>På tyska står huvudordet, det ägda <i>före</i> genitiven (den som äger).
    Att formen är genitiv framgår av de bestämda artiklarna (<i>d<b>es</b></i> eller <i>d<b>er</b></i>) eller andra bestämningsord framför
    (t.ex <i>mein<b>es</b></i>, <i>mein<b>er</b></i>),
    som böjts i genitiv. Ändelsen <b>-[e]s</b> läggs även på genitivordet om det är
    maskulinum eller neutrum singular, men INTE i femininum eller plural.</p>


<div class="ruta">

    <div class="quasi-p">
    <div class="p-stil"><div class="dubbelrad"><u><i>Der Traktor</i></u> &nbsp; <br><div class="minitext">huvudord</div></div></div>
    <div class="p-stil"><div class="dubbelrad"><u><i> <b>des</b> Bauer<b>s</b></i></u>&nbsp;<br><div class="minitext">genitiv</div></div></div>
    <div class="upp"><i>ist rot.</i></div>
    </div>


    <div class="quasi-p">
    <div class="p-stil"><div class="dubbelrad"><u><i>Die Lage</i></u> &nbsp; <br><div class="minitext">huvudord</div></div></div>
    <div class="p-stil"><div class="dubbelrad"><u><i> <b>des</b> Haus<b>es</b></i></u>&nbsp;<br><div class="minitext">genitiv</div></div></div>
    <div class="upp"><i>ist fantastisch.</i></div>
    </div>

    <div class="quasi-p">
    <div class="p-stil"><div class="dubbelrad"><u><i>Das Auto</i></u> &nbsp; <br><div class="minitext">huvudord</div></div></div>
    <div class="p-stil"><div class="dubbelrad"><u><i> <b>der</b> Lehrerin</i></u>&nbsp;<br><div class="minitext">genitiv</div></div></div>
    <div class="upp"><i>ist grün.</i></div>
    </div>



    <div class="quasi-p">
    <div class="p-stil"><div class="dubbelrad"><u><i>Die Bücher</i></u> &nbsp; <br><div class="minitext">huvudord</div></div></div>
    <div class="p-stil"><div class="dubbelrad"><u><i> <b>der</b> Kinder</i></u>&nbsp;<br><div class="minitext">genitiv</div></div></div>
    <div class="upp"><i>sind interessant.</i></div>
    </div>

</div>

<br><p>Det finita verbet böjs (singular eller plural) efter <i>huvudordet</i>, inte efter genitiven. Likaså är det huvudordet som påverkas
    av eventuella andra kasusformer som ackusativ eller dativ. Genitivformen förblir oförändrad.</p>

<div class="ruta">

    <div class="quasi-p">
    <div class="upp"><i>Ich gab </i></div>
    <div class="p-stil"><div class="dubbelrad"><u><i><b>dem</b> Lehrer</i></u> &nbsp; <br><div class="minitext">huvudord i dativ</div></div></div>
    <div class="p-stil"><div class="dubbelrad"><u><i> <b>des</b> Sohn<b>s</b></i></u>&nbsp;<br><div class="minitext">genitiv</div></div></div>
    <div class="upp"><i>einen Apfel.</i></div>
    </div>
    <p><i>Jag gav sonens lärare ett äpple.</i></p>


</div>



<br><br>

<h4 class="grammatikparagrafbredd leftorient">Bestämd artikel i alla kasus</h4><br>


    <table class="">

        <tr class="leftorient">
            <td></td>
            <td class="ljusgra">mask.</td>
            <td class="ljusgra">neutr.</td>
            <td class="ljusgra">fem.</td>
            <td class="ljusgra">plur.</td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">nom.</td>
            <td class="bgbla">der</td>
            <td class="bgbla">das</td>
            <td class="bgbla">die</td>
            <td class="bgbla">die</td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">ack.</td>
            <td class="bggron">den</td>
            <td class="bggron">das</td>
            <td class="bggron">die</td>
            <td class="bggron">die</td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">dat.</td>
            <td class="bgrod">dem</td>
            <td class="bgrod">dem</td>
            <td class="bgrod">der</td>
            <td class="bgrod">den ..n</td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">gen.</td>
            <td class="vit bggul"><b>des ..s</b></td>
            <td class="vit bggul"><b>des ..s</b></td>
            <td class="vit bggul"><b>der</b></td>
            <td class="vit bggul"><b>der</b> </td>
        </tr>
    </table><br>
    (genitiv gulmarkerad)
<br>
<div class="grammatikparagrafbredd leftorient">
    <p>Om genitiven, ägaren, i sin tur föregås av possessivt pronomen,
        böjs detta med samma ändelser som motsvarande bestämda artikel hade haft.</p>

<div class="ruta">
    <p><i><u>Min pappas</u> bil är långsam, så jag åker bara med <u>min mammas</u> bil.</i></p>
    <p><i>Das Auto <u>mein<b>es</b> Vater<b>s</b></u> ist langsam, so ich fahre nur mit dem Auto <u>mein<b>er</b> Mutter</u></i>.</p>
</div>
<br>
    <h4>Genitiv i tyskan även när svenskan använder prepositioner</h4>

    <p>Genitiv är vanligare i tyskan än i svenskan och används även där svenskan uttrycker ägande eller tillhörighet
        med hjälp av olika prepositioner (t.ex. på, till, i, av) istället för med genitiv:</p>




<div class="ruta">
    <p><i>Jag gillade inte färgen på huset</i>.<br>
    <i>Die Farbe <u><b>des</b> Haus<b>es</b></u> hat mir nicht gefallen</i>.</p>

    <p><i>Ägaren till hotellet var inte hemma</i>.<br>
    <i>Der Besitzer <u><b>des</b> Hotel<b>s</b></u> war nicht zu Hause</i>.</p>

    <p><i>Innehållet i talet var intetsägande</i>.<br>
    <i>Der Inhalt <u><b>der</b> Rede</u> war nichtssagend</i>.</p>


    <p><i>En del av problemet var redan löst.</i><br>
    <i>Ein teil <u><b>des</b> Problems</u> war schon gelöst</i>.</p>
</div>
</div>

<br>
<div class="grammatikparagrafbredd leftorient">
    <p class="mindre"><b>Talspråk</b></p>
    <p class="mindre">I tyskt <i>talspråk</i> uttrycks ägande i praktiken ofta med hjälp av prepositionen von (+dativ) istället för genitiv.</p>

<div class="ruta">

    <p class="mindre"><i>Bondens traktor är röd.<br>
    Der Traktor <b>vom</b> Bauer ist rot</i>.</p>

    <p class="mindre"><i>Lärarinnans bil är grön<br>
     Das Auto <b>von</b> der Lehrerin ist grün</i>.</p>
</div>
</div>



</div>
</div>


</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},
metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "genitiv ägande"
            }
        ]
    }
},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
